/* eslint-disable no-useless-catch */
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/order-options';

export const OrderOptionApi = {
  updateMulti: async (body: UpdateMultiOrderOptionsBuyOrderIDBody) => {
    const url = `${pathname}/multi`;
    try {
      const response = await entityService.post(url, body);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export interface UpdateMultiOrderOptionsBuyOrderIDBody {
  orderID: string;
  optionIDs: string[];
}
